import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-stipend-report',
  templateUrl: './my-stipend-report.component.html',
  styleUrls: ['./my-stipend-report.component.css']
})
export class MyStipendReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
